import React from 'react';
import {
  Box,
  Modal,
  Typography,
  Button,
  CircularProgress,
  useTheme
} from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import { deleteDeviceToken } from './deviceTokenDelete';
import { useColors } from '../Theme/ColorModeContext';

const ErrorModal = ({ open, onRetry }) => {
  const theme = useTheme();
  const { user, logout} = useAuth0();
  const colors = useColors()

  const invalidateSession = async() => {
    try {
      await axios.post(`${process.env.REACT_APP_BASE_URL}users/${user?.sub_id}/sessions/invalidate`, {}, {headers:{'Authorization': `Bearer ${localStorage.getItem('token') ? localStorage.getItem('token') : null}`}})

    } catch(error) {
      console.log("invalidateSession error ",error)
    }
  }
  
  const logoutAfterTokenExpired = async() => {
    try {
      await axios.get(`${process.env.REACT_APP_BASE_URL}oauth/logout`, {headers:{'Authorization': `Bearer ${localStorage.getItem('token') ? localStorage.getItem('token') : null}`}})
      
    } catch(error) {
      console.log("logoutAfterTokenExpired error ",error)
    }
    }

  const handleLogout = async() => {
    await deleteDeviceToken()
    await invalidateSession()
    await logoutAfterTokenExpired()
    localStorage.clear();
    localStorage.setItem('logout', true);
    logout({ logoutParams: { returnTo: window.location.origin } })
  }


  return (
    <Modal
      open={open}
      aria-labelledby="error-modal-title"
      aria-describedby="error-modal-description"
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          backgroundColor: theme.palette.background.paper,
          boxShadow: theme.shadows[24],
          padding: theme.spacing(4),
          borderRadius: theme.shape.borderRadius,
          outline: 'none',
          maxWidth: 400,
          width: {xs:"90%",sm:'100%'},
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: theme.spacing(2),
        }}
      >
        <ErrorOutlineIcon
          color="error"
          sx={{ fontSize: 60 }}
        />
        
        {/* <Typography
          id="error-modal-title"
          variant="h5"
          component="h2"
          color="error"
          gutterBottom
        >
          Error
        </Typography> */}
        
        <Typography
          id="error-modal-description"
          variant="body1"
        //   sx={{ mb: 2 }}
        >
          Your session may have timed out.
        </Typography>
        
        <Button
          variant="contained"
          onClick={handleLogout}
sx={{
  mt: 2,
  minWidth: 120,
  bgcolor: colors.primary.main,
  "&:hover": {
    bgcolor: colors.primary.main,
  },
}}
        >
         Ok
        </Button>
      </Box>
    </Modal>
  );
};

export default ErrorModal;